import axiosInstance from '../../../config/axiosConfig';
import { urlTipoAmenaza } from '../../../config/apiURL';
import { extractArray, extractDataObject } from '../../utils/responseHelpers';

// Obtener todos los tipos de amenaza
export async function getTipoAmenazas() {
  try {
    const response = await axiosInstance.get(urlTipoAmenaza);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching tipo amenazas:', error);
    throw error;
  }
}

// Obtener un tipo de amenaza por ID
export async function getTipoAmenazaById(id) {
  try {
    const response = await axiosInstance.get(`${urlTipoAmenaza}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching tipo amenaza ${id}:`, error);
    throw error;
  }
}

export async function createTipoAmenaza(formulario) {
  try {
    const response = await axiosInstance.post(urlTipoAmenaza, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating tipo amenaza:', error);
    throw error;
  }
}

export async function updateTipoAmenaza(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlTipoAmenaza}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating tipo amenaza ${id}:`, error);
    throw error;
  }
}

export async function deleteTipoAmenaza(id) {
  try {
    const response = await axiosInstance.delete(`${urlTipoAmenaza}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting tipo amenaza ${id}:`, error);
    throw error;
  }
}